if (!customElements.get('minicart-recommendations')) {
    customElements.define('minicart-recommendations', class MiniCartRecommendations extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.slider = this.querySelector('.cart-upsell__slider');
        this.track = this.querySelector('.cart-upsell__track');
        this.prevBtn = this.querySelector('[data-action="prev"]');
        this.nextBtn = this.querySelector('[data-action="next"]');

        if (!this.slider || !this.track) return;
        this.bindEvents();
        this.updateNavButtons();
      }
  
      bindEvents() {
        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => this.scrollPrev());
        }
  
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => this.scrollNext());
        }
  
        this.slider.addEventListener('scroll', () => this.updateNavButtons(), { passive: true });
      }
  
      scrollNext() {
        const scrollAmount = this.getScrollStep();
        this.slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
  
      scrollPrev() {
        const scrollAmount = this.getScrollStep();
        this.slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      }
  
      getScrollStep() {
        const firstCard = this.track.querySelector('.cart-upsell__card');
        if (!firstCard) return 170;
        
        const gap = parseInt(window.getComputedStyle(this.track).gap) || 12;
        return firstCard.offsetWidth + gap;
      }
  
      updateNavButtons() {
        if (!this.prevBtn || !this.nextBtn) return;
  
        const scrollLeft = Math.ceil(this.slider.scrollLeft);
        const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;
  
        this.prevBtn.disabled = scrollLeft <= 0;
        this.nextBtn.disabled = scrollLeft >= maxScrollLeft - 2;
      }
    });
}